// extracted by mini-css-extract-plugin
export default {"container":"RateSummaryNeedsAtention_container__FWBvw"};